import { useQuery } from '@tanstack/react-query';
import type { ExportRequest } from '@/features/agent/export_requests/types/ExportRequest';

export default function useFetchExportRequestsDetails(id: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['export_requests_details', id],
    queryFn: async () => {
      const response = await fetch(`/agent/api/export_requests/${id}`);
      if (!response.ok) {
        throw new Error('Failed to fetch export details');
      }
      const data: ExportRequest = await response.json();

      return data;
    },
    enabled: options?.enabled !== false,
  });
}
